export const stagingImages = [
  {
    index: 0,
    before: 'https://cdn.hauslifenetwork.com/9633/2D/9633_10569_20_thumb.jpg',
    after: 'https://cdn.hauslifenetwork.com/9633/2D/9633_10569_49_thumb.jpg',
  },
  {
    index: 1,
    before: 'https://cdn.hauslifenetwork.com/9633/2D/9633_10569_34_thumb.jpg',
    after: 'https://cdn.hauslifenetwork.com/9633/2D/9633_10569_53_thumb.jpg',
  },
  {
    index: 2,
    before: 'https://cdn.hauslifenetwork.com/9633/2D/9633_10569_33_thumb.jpg',
    after: 'https://cdn.hauslifenetwork.com/9633/2D/9633_10569_52_thumb.jpg',
  },
  {
    index: 3,
    before: 'https://cdn.hauslifenetwork.com/9633/2D/9633_10569_22_thumb.jpg',
    after: 'https://cdn.hauslifenetwork.com/9633/2D/9633_10569_51_thumb.jpg',
  },
  {
    index: 4,
    before: 'https://cdn.hauslifenetwork.com/9633/2D/9633_10569_35_thumb.jpg',
    after: 'https://cdn.hauslifenetwork.com/9633/2D/9633_10569_54_thumb.jpg',
  },
];
